module.exports = __webpack_public_path__ + "img/publicacaov2.58f760fe.jpg";